RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.OverLandscapeLimitModal = Marionette.ItemView.extend({
        ui: {
            modal: '.modal',
            viewPlansBtn: '.x-view-plans'
        },

        events: {
            'click @ui.viewPlansBtn': 'onViewPlansClick'
        },

        template: '#overLandscapeLimitModalTemplate',

        templateHelpers: function () {
            return {
                formatLabeledNumber: RivalIQ.formatter.formatLabeledNumber
            };
        },

        onRender: function () {
            const me = this;

            me.ui.modal.modal();

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.AddLandscapeHitLimit);

            me.sendNotification();
        },

        sendNotification: function () {
            $.post('/api/account/landscapeLimitReached');
        },

        onViewPlansClick: function () {
            const me = this;

            me.ui.modal.modal('hide');

            window.location.href = '/manage#subscription';
        }

    });

});
